import { Link } from "react-router-dom";
import { BLOG_POSTS } from "../data/blogPosts";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

// Format ISO date (YYYY-MM-DD) as "August 10, 2026" without pulling in a date
// library — matches the tone of the LegalPage "Last updated" strings.
const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
function formatDate(iso) {
  const [y, m, d] = iso.split("-").map((s) => parseInt(s, 10));
  return `${MONTHS[m - 1]} ${d}, ${y}`;
}

/**
 * /blog — index of all blog posts. Mirrors PhilosopherIndex's layout and copy
 * conventions so the two hubs feel like siblings, not two different sites.
 */
export default function BlogIndex() {
  const sorted = [...BLOG_POSTS].sort((a, b) =>
    b.datePublished.localeCompare(a.datePublished),
  );

  return (
    <div
      className="relative z-10 mx-auto min-h-[100dvh] w-full px-5 py-14"
      data-testid="blog-index-screen"
    >
      <SEOHead
        title="Blog"
        description="Essays and long reads on personality, philosophy, and the six traits that power The Philosopher Test."
        path="/blog"
      />
      <div style={{ maxWidth: 780, margin: "0 auto" }}>
        <p
          className="text-[11px] font-medium uppercase"
          style={{ color: "var(--muted)", letterSpacing: "0.32em" }}
        >
          The Philosopher Test · Blog
        </p>
        <h1
          className="mt-3 font-serif text-[36px] sm:text-[46px] leading-[1.08]"
          style={{ color: "var(--gold)" }}
          data-testid="blog-index-h1"
        >
          The Philosopher Test Blog
        </h1>
        <p
          className="mt-4 max-w-xl text-[16px] leading-relaxed"
          style={{ color: "var(--text)" }}
        >
          Essays and long reads on personality, philosophy, and the six traits
          that power the test. New pieces are added slowly and on purpose.
        </p>

        <div className="mt-10 flex flex-col gap-6">
          {sorted.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="panel block transition-colors"
              data-testid={`blog-card-${post.slug}`}
              style={{ color: "var(--text)" }}
            >
              <p
                className="text-[10px] font-medium uppercase"
                style={{ color: "var(--gold)", letterSpacing: "0.32em" }}
              >
                {formatDate(post.datePublished)}
              </p>
              <h2
                className="mt-2 font-serif text-[22px] leading-[1.2]"
                style={{ color: "var(--text)" }}
              >
                {post.title}
              </h2>
              <p
                className="mt-3 text-[13px] leading-relaxed"
                style={{ color: "var(--muted)" }}
              >
                {post.metaDescription}
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3">
          <Link
            to="/"
            className="btn-primary text-center"
            data-testid="blog-index-cta-take-test"
          >
            Take The Philosopher Test
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
